export default __webpack_public_path__ + "static/media/focusIcon2.7baee5ab.svg";